var Away3D = (function () {
    function Away3D() {
    }
    return Away3D;
}());
export { Away3D };
